import { combineReducers } from 'redux';
import authReducer from './authReducer';
import featureReducer from './featureReducer';
// import { persistReducer } from 'redux-persist';
// import storage from 'redux-persist/lib/storage';
import userReducer from './UserReducer';
import gradeReducer from './gradeReducer';
import serviceLineReducer from './serviceLineReducer';
import wfhProfileReducer from './wfhProfileReducer';
import deskReducer from './deskReducer';
import spotReducer from './spotReducer';
import accessReducer from './accessReducer';
import floorReducer from './floorReducer';
import zoneReducer from './zoneReducer';
import accessProfileReducer from './accessProfileReducer';
import permissionReducer from './permissionReducer';
import notificationReducer from './notificationReducer';
import claimReducer from './claimReducer';
import untracedUsersReducer from './untracedUsersReducer';
import combinedModesReducer from './combinedModesReducer';
import wfhReducer from './wfhReducer';
import wfhBalanceReducer from './wfhBalanceReducer';
import thirdPartySiteReducer from './thirdPartySiteReducer';
import operationReducer from './operationReducer';
import balanceReducer from './balanceReducer';
import requestReducer from './requestReducer';
import dashboardReducer from './dashboardReducer';
import missionReducer from './missionReducer';
import buildingReducer from './buildingReducer';
import cronReducer from './cronReducer';

// const persistConfig = {
//   key: 'feature',
//   storage,
//   whitelist: ['feature']
// };

// const persistedModuleReducer = persistReducer(
//   persistConfig,
//   featureReducer as Reducer<FeatureState>
// );

const rootReducer = combineReducers({
  auth: authReducer,
  // feature: persistReducer(persistConfig, featureReducer as Reducer<FeatureState>)
  feature: featureReducer,
  users: userReducer,
  grade: gradeReducer,
  serviceLine: serviceLineReducer,
  wfhProfile: wfhProfileReducer,
  desk: deskReducer,
  spot: spotReducer,
  access: accessReducer,
  floor: floorReducer,
  zone: zoneReducer,
  accessProfile: accessProfileReducer,
  permissions: permissionReducer,
  claim: claimReducer,
  untracedUsers: untracedUsersReducer,
  combinedModes: combinedModesReducer,
  wfh: wfhReducer,
  wfhBalance: wfhBalanceReducer,
  thirdPartySite: thirdPartySiteReducer,
  operation: operationReducer,
  balance: balanceReducer,
  request: requestReducer,
  dashboard: dashboardReducer,
  missions: missionReducer,
  building: buildingReducer,
  cron: cronReducer
});

export default rootReducer;
// export default persistReducer(persistConfig, rootReducer);
